// elements.module.js

"use strict";

import angular from "angular";
import angularMoment from 'angular-moment';

import {
    PreloaderController,
    SubmitButtonController,
    tooltipController,
    modalMapController,
    inputCheckBoxController,
    inputCheckBoxPrivacyController,
   
  //  inputFileYandexController,
    //inputFileCardController,
    inputBankController,
    inputTextSwitchController,
    inputTextController,
    inputSwitchController,

    inputRegistrationController,
    
    inputGenderController,
    inputSNILSController,
    inputFioController,
    inputOGRNController,
    inputEGRIPController,
    inputYearMonthController
} from "./elements.controllers.module";

import  {inputSelectController} from "./input.select.controller";
import  {
    inputDatePickerController,
    inputDatePickerWithSwitchController
} from "./input.date.picker.controller";
import  {inputIdentityCardController} from "./input.identity.card.controller";

import {
    inputFileCardController,
    inputFileOneController
}from "./elements.file.card.module";

import {inputFileYandexController} from  "./elements.file.yandex.module";
import { 
    inputAddressController,
    inputAddressEnergoController,
    inputAddressVlInfoController
} from "./input.address.controller";

import {sectionDesignerController}  from "./section.designer.module";

const ELEMENTS_MODULE = angular
  .module("moetp.formelements", [
    angularMoment
  ])

  

  .component('sectionDesigner', {
    template: require('./html/section-designer.html'),
    controller: sectionDesignerController,
    bindings: {
        model: '=',
    }
  })

  .component('inputFio', {
    template: require('./html/fio.html'),
    controller: inputFioController,
    bindings: {
        model: '=',
        fieldName:'@?',
        tootltip:'@?',
        notAllowEmpty:'@?'
    }
  })
.component('inputSnils', {
    template: require('./html/snils.html'),
    controller: inputSNILSController,
    bindings: {
        model: '=',
        fieldName:'@?',
        label:'@',
        tootltip:'@?',
        notAllowEmpty:'@?',
        mask:'='
    }
})


.component('inputGender', {
    template: require('./html/gender.html'),
    controller: inputGenderController,
    bindings: {
        model: '=',
        fieldName:'@?',
        tootltip:'@?',
    }
})


.component('inputIdentityCard', {
    template: require('./html/identity-card.html'),
    controller: inputIdentityCardController,
    bindings: {
        model: '=',
        fieldName:'@?',
        label:'@',
        tootltip:'@?',
        skeepCheckFill:'=',
        hideMini:'@?'
    }
})

.component('inputRegistration', {
    template: require('./html/registration.html'),
    controller: inputRegistrationController,
    bindings: {
      model: '=',
      fieldName:'@?',
      tootltip:'@?',
    }
})


.component('inputAddress', {
    template: require('./html/address.html'),
    controller: inputAddressController,
    bindings: {
        label:'@',
        model: '=',
        hideIndex: '@?',
        hideIndexBlock: '@?',
        showCheck: '@?',
        fieldName:'@?',
        defaultRegion:'@?',
        tootltip:'@?',
        notAllowEmpty:'=?',
        typeCheck:"@?"

    }
})

.component('inputAddressEnergo', {
    template: require('./html/address-energo.html'),
    controller: inputAddressEnergoController,
    bindings: {
        label:'@',
        model: '=',
        hideIndex: '@',
        showCheck: '@?',
        fieldName:'@?',
        tootltip:'@?',
        filter: '=',
        isAutoCreate:'='
    }
})
.component('inputAddressEnergoLimit', {
    template: require('./html/address-energo-limit.html'),
    controller: inputAddressEnergoController,
    bindings: {
        label:'@',
        model: '=',
        hideIndex: '@',
        showCheck: '@?',
        fieldName:'@?',
        tootltip:'@?'
    }
})


.component('inputAddressVlInfo', {
    template: require('./html/address-vl-info.html'),
    controller: inputAddressVlInfoController,
    bindings: {
        label:'@',
        model: '=',
        hideIndex: '@',
        showCheck: '@?',
        fieldName:'@?',
        tootltip:'@?',
    }
})



.component('inputAddressEnergoInfoVl', {
    template: require('./html/address-energo-info-vl.html'),
    controller: inputAddressEnergoController,
    bindings: {
        label:'@',
        model: '=',
        hideIndex: '@',
        showCheck: '@?',
        fieldName:'@?',
        tootltip:'@?',
    }
})


.component('inputDatePicker', {
    template: require('./html/datepicker.html'),
    controller: inputDatePickerController,
    bindings: {
        label:'@',
        model: '=',
        fieldName:'@?',
        tootltip:'@?',
        notAllowEmpty:'=?',
        mask:"=",
        outputType:"@",
        onlyFuture:'@?'

    }
})

.component('inputDatePickerWithSwitch', {
    template: require('./html/datepicker-with-switch.html'),
    controller: inputDatePickerWithSwitchController,
    bindings: {
        label:'@',
        model: '=',
        fieldName:'@?',
        tootltip:'@?',
        notAllowEmpty:'=?',
        mask:"=",
        textDisable:'@',
        textEnable:'@',
        disableModel:'='
    }
})


.component('inputSwitch', {
    template: require('./html/switcher.html'),
    controller: inputSwitchController,
    bindings: {
        textNot: '@',
        textYes: '@',
        bxType: '@',
        isBig: '<',
        model: '=',
        fieldName:'@?',
        label:'@?',
       
    }
})

.component('inputText', {
    template: require('./html/input-text.html'),
    controller: inputTextController,
    bindings: {
      placeholder:'@?',
      label:'@',
      model: '=',
      onInit: '&',
      onChanged:'&',
      onStartType:'&',
      mask:"=",
      isDisabled:'=',
      fieldName:'@?',
      notAllowEmpty:'=?',
      haveError:'=?',
      errorMessage:'=?'

    }
})
.component('inputTextArea', {
    template: require('./html/input-text-area.html'),
    controller: inputTextController,
    bindings: {
      label:'@',
      model: '=',
      onInit: '&',
      onChanged:'&',
      onStartType:'&',
      mask:"=",
      isDisabled:'=',
      fieldName:'@?',
      notAllowEmpty:'=?',
      haveError:'=?',
      errorMessage:'=?'
    }
})
.component('inputTextSwitch', {
    template: require('./html/input-text-switch.html'),
    controller: inputTextSwitchController,
    bindings: {
      label:'@',
      model: '=',
      switch: '=',
      onInit: '&',
      onChanged:'&',
      onStartType:'&',
      mask:"=",
      isDisabled:'=',
      fieldName:'@?'

    }
})
.component('inputOgrn', {
    template: require('./html/ogrn.html'),
    controller: inputOGRNController,
    bindings: {
      label:'@',
      model: '=',
      fieldName:'@?',
      tootltip:'@?',
      notAllowEmpty:'=?',
    }
})

.component('inputEgrip', {
    template: require('./html/ogrn.html'),
    controller: inputEGRIPController,
    bindings: {
      label:'@',
      model: '=',
      fieldName:'@?',
      tootltip:'@?',
      notAllowEmpty:'=?',
    }
})



.component('inputBank', {
    template: require('./html/bank.html'),
    controller: inputBankController,
    bindings: {

      model: '=',
      modelKpp: '=',
      fieldName:'@?',
      tootltip:'@?',
      notAllowEmpty:'=?'
    }
})
.component('inputFile', {
    template: require('./html/file.html'),
    controller: inputFileCardController,
    bindings: {
      label:'@',
      model: '=',
      fileId:'@',
      cid:'@',
      fieldName:'@?',
      tootltip:'@?',
    }
})
.component('inputFileGroup', {
    template: require('./html/file-group.html'),
    controller: inputFileCardController,
    bindings: {
      label:'@',
      model: '=',
      fileId:'@',
      cid:'@',
      fieldName:'@?',
      tootltip:'@?',

    }
})
.component('inputFileOne', {
    template: require('./html/file-one.html'),
    controller: inputFileOneController,
    bindings: {
      label:'@',
      model: '=',
      fileId:'@',
      cid:'@',
      fieldName:'@?',
      tootltip:'@?',
      onUploadComplete:'&',

    }
})

.component('inputFileGroupDocs', {
    template: require('./html/file-group-docs.html'),
    controller: inputFileCardController,
    bindings: {
      label:'@',
      model: '=',
      fileId:'@',
      cid:'@',
      fieldName:'@?',
      tootltip:'@?',

    }
})

.component('inputFileGroupProjects', {
    template: require('./html/file-group-projects.html'),
    controller: inputFileCardController,
    bindings: {
      label:'@',
      model: '=',
      fileId:'@',
      cid:'@',
      fieldName:'@?',
      tootltip:'@?',
      disallowAdd:'=?'

    }
})

.component('inputFileGroupTu', {
    template: require('./html/file-group-tu.html'),
    controller: inputFileCardController,
    bindings: {
      label:'=',
      model: '=',
      fileId:'@',
      cid:'@',
      fieldName:'@?',
      tootltip:'@?',
      haveError:'=?',
      errorMessage:'=?',
      allowUpload:"="
    }
})

.component('inputFileYandex', {
    template: require('./html/file-yandex.html'),
    controller: inputFileYandexController,
    bindings: {
      label:'@',
      model: '=',
      fileId:'@',
      cid:'@',
      fieldName:'@?',
      tootltip:'@?',
      bid:'='
    }
})

.component('inputSelect', {
    template: require('./html/select.html'),
    controller: inputSelectController,
    bindings: {
      label:'@',
      model: '=',
      modelOpt: '=?',
      type:'@',
      placeholder: '@' ,
      options: '=?', 
      tootltip:'@?',
      fieldName:'@?',
      tag:'@?',
      onSelect:'&',
      filter:'@?',
      haveError:'=?',
      errorMessage:'=?',
      notAllowEmpty:'@?',
      
    }
})
.component('inputYearMonth', {
    template: require('./html/yearmonth.html'),
    controller: inputYearMonthController,
    bindings: {
      label:'@',
      model: '=',
      fieldName:'@?',
      notAllowEmpty:'=?'
      
    }
})
.component('inputCheckbox', {
    template: require('./html/checkbox.html'),
    controller: inputCheckBoxController,
    bindings: {
      label:'@',
      model: '=',
      fieldName:'@?',
      trueValue:'@?',
      falseValue:'@?'
      
    }
})
.component('inputCheckboxPrivacy', {
    template: require('./html/checkbox-privacy.html'),
    controller: inputCheckBoxPrivacyController,
    bindings: {
      label:'@',
      model: '=',
      fieldName:'@?',
      trueValue:'@?',
      falseValue:'@?'
      
    }
})
.component('modalMap', {
    template: require('./html/modal-map.html'),
    controller: modalMapController,
    bindings: {
      label:'@',
      model: '=',
      fieldName:'@?',
      visible: '=',
      onInited:'&',
      tootltip:'@?',
      onSaveYad:'&',
    }
})
.component('tooltip', {
    template: require('./html/tooltip.html'),
    controller: tooltipController,
    bindings: {
        errorMessage:'=',
        haveError: '=',
        fieldName:'=',
        fieldInfo:'=',
    }
})
.component('submitButton', {
    template:  require('./html/submit-button.html'),
    controller: SubmitButtonController,
    bindings: {
       
    }
})
.component('preloader', {
    template: '',
    controller: PreloaderController,
    bindings: {
        isStart:'=',
    }
})


;


 
  

export { ELEMENTS_MODULE };

  


// WEBPACK FOOTER //
// ./src/components/elements/elements.module.js